// extracted by mini-css-extract-plugin
export var baseButton = "_w2-0";
export var controlsArrowKeys = "_w2-1";
export var controlsResetButton = "_w2-2";
export var lightGameButton = "_w2-4 _w2-0";
export var playAgainButton = "_w2-5 _w2-0";
export var startGameButton = "_w2-3 _w2-0";